var map = {
	"./auth-bg-1.jpg": 11291,
	"./boxbg.jpg": 96709,
	"./calender-widget.jpg": 47241,
	"./caller.jpg": 95706,
	"./cart-img.jpg": 30635,
	"./coming-soon-bg.jpg": 45067,
	"./img-cropper.jpg": 22614,
	"./maintenance-bg.jpg": 94842,
	"./receiver-img.jpg": 59409,
	"./wallpaper.jpg": 86681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65307;